import React from 'react';

import Button from '@atlaskit/button/default/button';
import { PopupTrigger } from '@atlassian/entry-points/popup-trigger';

import { loadingPopupEntryPoint } from '../fixtures/constellation/loading-popup-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function PopupTriggerLoading(): React.JSX.Element {
	return (
		<RelayWrapper>
			<PopupTrigger
				entryPoint={loadingPopupEntryPoint}
				role="dialog"
				label="Loading example popup"
				placement="bottom-start"
				loadingText="Loading popup content"
				loadingCompleteText="Popup content loaded"
				trigger={(triggerProps) => (
					<Button {...triggerProps} appearance="primary" isSelected={triggerProps['aria-expanded']}>
						{triggerProps['aria-expanded'] ? 'Close popup' : 'Show loading popup'}
					</Button>
				)}
			/>
		</RelayWrapper>
	);
}
